export function absBigInt(n: bigint) {
  if (n < 0n) {
    return -n;
  }
  return n;
}
